<p-dialog header="{{massHeader}}" [(visible)]="displayAddEditMass" [modal]="true" [responsive]="true" [style]="{ width: '80vw'}" (onHide)="cancel()">
    <ng-container *ngIf="layerNo == 1">
        <div class="header p-d-flex p-jc-between">
            <h6 class="p-mt-2 p-mb-0">Select Data Using</h6>
            <p-selectButton [options]="methodOption" [(ngModel)]="methodValue" optionLabel="label" optionValue="value"></p-selectButton>
            <div class="btn-group">
                <!-- <p-button *ngIf="methodValue == 'manually'" icon="pi pi-plus"></p-button> -->
            </div>
        </div>
        <div class="card">
            <div [formGroup]="saveSearchForm" class="p-grid" *ngIf="methodValue == 'saveSearch'">
                <div class="p-col-12" style="display: relative;">
                    <label>Saved Search</label>
                    <span class="p-buttonset p-d-flex w-100">
                        <button pButton pRipple label="{{selectedSSName}}" class="p-button-outlined ddBtn"
                        (click)="op.toggle($event)"></button>
                        <button pButton pRipple icon="pi pi-angle-down" (click)="op.toggle($event)"></button>
                    </span>
                    <p-overlayPanel  #op styleClass="panel-in-dialog dd-panel">
                        <ng-template pTemplate>
                            <p-table #workflow [columns]="listCols" [value]="savedSearchesList" [paginator]="true" [style]="{width:'100%'}" [rows]="pageSize" [lazy]="true" [(first)]="first" [totalRecords]="totalRecords" (onLazyLoad)="getSavedSearchListByFilter($event)" selectionMode="single"
                                [(selection)]="selectedSearch" dataKey="id" responsiveLayout="scroll" (onRowSelect)="onRowSelect($eventd)" scrollHeight="25rem" [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                [rowsPerPageOptions]="tableShowMore">
                                <ng-template pTemplate="colgroup" let-columns>
                                    <colgroup>
                                        <ng-container *ngFor="let col of columns">
                                            <col *ngIf="col.show" style="width:auto">
                                        </ng-container>
                                    </colgroup>
                                </ng-template>
                                <ng-template pTemplate="header" let-columns>
                                    <tr>
                                        <ng-container *ngFor="let col of columns">
                                            <th *ngIf="col.show" [pSortableColumn]="col.field">
                                                {{col.header}}
                                                <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order">
                                                </p-sortIcon>
                                                <span class="pi pi-filter p-ml-2 filtericon" [ngClass]="{'blink_me' : col.value.length > 0}" (click)="$event.stopPropagation(); curCol = col; filter.toggle($event)">
                                                </span>
                                            </th>
                                        </ng-container>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-rowData let-columns="columns">
                                    <tr [pSelectableRow]="rowData" [pContextMenuRow]="rowData">
                                        <ng-container *ngFor="let col of columns">
                                            <td *ngIf="col.show" style="text-align: left;">
                                                <ng-container [ngSwitch]="col?.dataType">
                                                    <ng-container *ngSwitchCase="'date'">
                                                        <div>
                                                            {{ rowData[col.field] | date:'MM/dd/yyyy' }}
                                                        </div>
                                                    </ng-container>
                                                    <ng-container *ngSwitchDefault>
                                                        <div>
                                                            {{ rowData[col.field] }}
                                                        </div>
                                                    </ng-container>
                                                </ng-container>
                                            </td>
                                        </ng-container>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="6">{{noSearchesFindOrLoadingText}}</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                            <p-overlayPanel #filter [showCloseIcon]="false" [dismissable]="true">
                                <ng-template pTemplate>
                                    <input pInputText type="text" #inputS [(ngModel)]="curCol.value" (input)="workflow.filter(curCol.value, curCol.field, 'contains')" placeholder="Search by {{curCol.header}}" class="p-column-filter" [value]="workflow.filters[curCol.field] ? workflow.filters[curCol.field].value : ''">
                                </ng-template>
                            </p-overlayPanel>
                        </ng-template>
                    </p-overlayPanel>
                </div>
                <div class="p-col-12">
                    <div class="p-grid">
                        <div class="p-col-12 p-md-6">
                            <label>Name <span style="color: red;">*</span></label>
                            <input type="text" formControlName="name" pInputText>
                        </div>
                        <div class="p-col-12 p-md-6">
                          <label>Access Permission<span style="color: red;">*</span></label>
                          <p-multiSelect appendTo="body"  optionLabel="name" [options]="users" [(ngModel)]="selectedUser"
                          formControlName="accessPermission" ></p-multiSelect>
                        </div>
                    </div>
                    <div class="p-grid" >
                        <div class="p-col-6">
                            <label>Module<span style="color: red;">*</span></label>
                            <p-dropdown appendTo="body" [options]="allModules" formControlName="module"
                            [(ngModel)]="selectedModule" optionLabel="name" id="allModules"
                            dataKey="id" placeholder="Select a  Module"
                            (onChange)="getChannelList(selectedModule)" required>
                            </p-dropdown>
                        </div>
                        <div class="p-col-6">
                            <label>Channel<span style="color: red;">*</span></label>
                            <p-dropdown appendTo="body" [options]="allChannels" formControlName="channel"
                                [(ngModel)]="selectedChannel" optionLabel="name" id="allChannels"
                                dataKey="id" placeholder="Select Channel" required>
                            </p-dropdown>
                        </div>
                    </div>
                </div>
            </div>
            <!-- *ngIf="methodValue == 'manually'"    Form Needed-->
            <div class="card"  *ngIf="methodValue == 'manually'">
                <div class="p-grid">
                    <div class="p-col-12 p-md-6">
                        <label>Name <span style="color: red;">*</span></label>
                        <input type="text" pInputText>
                    </div>
                    <div class="p-col-12 p-md-6">
                      <label>Access Permission <span style="color: red;">*</span></label>
                      <p-multiSelect appendTo="body"  optionLabel="name" [options]="users" [(ngModel)]="selectedUser"
                      name="selectedUser"></p-multiSelect>
                    </div>
                </div>
                <div class="p-grid" >
                    <div class="p-col-6">
                        <label>Module</label>
                        <p-dropdown appendTo="body" [options]="allModules" name="allModules"
                        [(ngModel)]="selectedModule" optionLabel="name" id="allModules"
                        dataKey="id" placeholder="Select a  Module"
                        (onChange)="getChannelList(selectedModule)" required>
                        </p-dropdown>
                    </div>
                    <div class="p-col-6">
                        <label>Channel</label>
                        <p-dropdown appendTo="body" [options]="allChannels" name="allChannels"
                            [(ngModel)]="selectedChannel" optionLabel="name" id="allChannels"
                            dataKey="id" placeholder="Select Channel" required>
                        </p-dropdown>
                    </div>
                </div>
            </div>

        </div>
    </ng-container>
    <ng-container *ngIf="layerNo == 2">
        <div class="card" *ngIf="methodValue == 'saveSearch'">
            <p-table [value]="resultData" [columns]="selectedSearch?.columns" [(rows)]="pageSize2" [showCurrentPageReport]="true" [rowsPerPageOptions]="tableShowMore2" [totalRecords]="totalRecords2" class="caption-no-padding" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                [paginator]="true" [(first)]="first2" styleClass="p-datatable-striped" responsiveLayout="scroll" [lazy]="true" (onLazyLoad)="getSavedSearchResultByFilter($event)" selectionMode="multiple" [(selection)]="selectedSavedSearch" dataKey="Id">
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-jc-between">
                        <!-- Filter Component -->
                        <app-filter [filterByInput]="selectedSearch?.columns" [filterByInputValue]="filterByInputValue" [isShowAllDateFilter]="true" [enableAPIFilter]="true" (onApplyFilter)="onApplyFilter($event)" (onModifyFilterOptions)="onModifyFilterOptions($event)" (onChangeRange)="onChangeRange($event)"
                            (onRemoveFilter)="onRemoveFilter($event)" (onOptionsFilter)="onOptionsFilter($event)" style="width: 100%;" [panelDialog]="true">
                        </app-filter>
                        <span class="btnBars p-mr-0 p-mt-4" (click)="showColumnSetting()" pTooltip="Column Setting" tooltipPosition="top">
                            <i class="pi pi-cog"></i>
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header" let-rowData let-columns>
                    <tr>
                        <th style="width: 3rem">
                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                        </th>
                        <ng-container *ngFor="let col of columns">
                            <th *ngIf="col?.isShow == true">
                                {{col.header}}
                            </th>
                        </ng-container>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
                    <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="rowIndex">
                        <td>
                            <p-tableCheckbox [pSelectableRow]="rowData" [value]="rowData"></p-tableCheckbox>
                        </td>
                        <ng-container *ngFor="let col of columns">
                            <td *ngIf="col?.isShow == true">
                                <ng-container [ngSwitch]="col?.dataType">
                                    <ng-container *ngSwitchCase="'date'">
                                        {{ rowData[col.field] | localDate:'MM/DD/YYYY' }}
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'number'">
                                        {{ rowData[col.field] }}
                                    </ng-container>
                                    <ng-container *ngSwitchDefault>
                                        <span *ngIf="col?.fieldNameDB?.toLowerCase() == 'businessname' || col?.fieldNameDB?.toLowerCase() == 'name'" class="saved-search-popup-link" (click)="onRouteNavigation(rowData, col)">
                                            {{ rowData[col.field] }}
                                        </span>
                                        <span *ngIf="col?.fieldNameDB?.toLowerCase() != 'businessname' && col?.fieldNameDB?.toLowerCase() != 'name'">
                                            {{ rowData[col.field] }}
                                        </span>
                                    </ng-container>
                                </ng-container>
                            </td>
                        </ng-container>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="18">{{noData}}</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        <div class="card" *ngIf="methodValue == 'manually'">
            <!-- Account -->
            <p-table #accountsTable [columns]="accountCols" class="accountTable" [(first)]="first3" [scrollable]="true" [lazy]="true" (onLazyLoad)="getAllAcountsWithPagination($event)" [totalRecords]="totalRecords3" [loading]="loading" [style]="{width:'100%'}" [value]="rowGroupMetadata"
                [rows]="pageSize3" [paginator]="true" selectionMode="multiple" [(selection)]="selectedAccounts" dataKey="id" [expandedRowKeys]="expandedRows" [expandableRows]="true" [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                [rowsPerPageOptions]="tableShowMore3" *ngIf="selectedModule.name == 'Account'">
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-jc-between">
                        <!-- Filter Component -->
                        <app-filter [filterByInput]="activeAccountCols" [filterByInputValue]="filterByInputValue" [isShowAllDateFilter]="true" [enableAPIFilter]="true" (onApplyFilter)="onApplyFilter($event)" (onModifyFilterOptions)="onModifyFilterOptions($event)" (onChangeRange)="onChangeRange($event)"
                            (onRemoveFilter)="onRemoveFilter($event)" (onOptionsFilter)="onOptionsFilter($event)" style="width: 100%;" [panelDialog]="true">
                        </app-filter>
                        <span class="btnBars p-mr-0 p-mt-4" (click)="showColumnSetting()" pTooltip="Column Setting" tooltipPosition="top">
                            <i class="pi pi-cog"></i>
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="colgroup" let-columns>
                    <colgroup>
                        <col style="width:4rem">
                        <ng-container *ngFor="let col of columns">
                            <col *ngIf="col.ischecked" style="width:auto">
                        </ng-container>
                    </colgroup>
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th style="width: 3rem; max-width: 3rem;">
                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                        </th>
                        <th style="width: 4rem; max-width: 4rem;"></th>
                        <ng-container *ngFor="let col of columns">
                            <th *ngIf="col.ischecked" [pSortableColumn]="col.field">
                                {{col.labelname}}
                                <span class="pi pi-filter p-mr-2 filtericon" [ngClass]="{'blink_me' : col.value && col.value.length > 0}" (click)="$event.stopPropagation(); currentCol = col; filters.toggle($event)">
                                </span>
                            </th>
                        </ng-container>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded">
                    <tr [pSelectableRow]="rowData" [pContextMenuRow]="rowData">
                        <td style="width: 3rem; max-width: 3rem;">
                            <p-tableCheckbox [pSelectableRow]="rowData" [value]="rowData"></p-tableCheckbox>
                        </td>
                        <!-- start for space rowexpansion -->
                        <td style="width: 4rem; max-width: 4rem;" *ngIf="rowData.hasChildAccounts; else selectionEnabledTemplate">
                            <button type="button" [pRowToggler]="rowData" pButton pRipple class="p-button-text p-button-rounded p-button-plain" (click)="onExpandRow(rowData.id, rowData, expanded)" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
                            </button>
                        </td>
                        <ng-template #selectionEnabledTemplate>
                            <td style="width: 4rem; max-width: 4rem;"></td>
                        </ng-template>
                        <!-- end for space rowexpansion -->
                        <ng-container *ngFor="let col of columns">
                            <td *ngIf="col.ischecked" style="text-align: left;">
                                <ng-container *ngIf="!col?.depth; else depthTemplate">
                                    <ng-container *ngIf="col.field =='businessName'; else elseData">
                                        <app-color-box class="colorBoxStyle" [color]="rowData.classificationColor"></app-color-box>
                                        {{ rowData[col.field] | shorten:27 }}
                                    </ng-container>
                                    <ng-template #elseData>
                                        {{ rowData[col.field] | shorten:27 }}
                                    </ng-template>
                                </ng-container>
                                <ng-template #depthTemplate>
                                    {{ rowData | field:col?.depth }}
                                </ng-template>
                            </td>
                        </ng-container>
                    </tr>
                </ng-template>
                <ng-template pTemplate="rowexpansion" let-rowData let-columns="columns" #depth>
                    <ng-template [ngTemplateOutlet]="Recursion" [ngTemplateOutletContext]="{$implicit: rowData, columns:columns}"></ng-template>
                </ng-template>
                <ng-template let-rowData let-columns="columns" #Recursion>
                    <!-- @@@ {{rowData[0].childAccount}} -->
                    <ng-container *ngFor="let children of rowData.childAccount">
                        <ng-container *ngIf="rowData.viewDetails">
                            <tr class="child-color" [pSelectableRow]="children" [pContextMenuRow]="children">
                                <td style="width: 3rem; max-width: 3rem;">
                                    <p-tableCheckbox [pSelectableRow]="children" [value]="children"></p-tableCheckbox>
                                </td>
                                <!-- start for space rowexpansion -->
                                <td style="width: 4rem; max-width: 4rem;" *ngIf="children.hasChildAccounts; else selectionEnabledTemplate">
                                    <button type="button" [pRowToggler]="children" pButton pRipple class="p-button-text p-button-rounded p-button-plain" (click)="onExpandRow(children.id, children, children.viewDetails)" [icon]="children.viewDetails ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                                </td>
                                <ng-template #selectionEnabledTemplate>
                                    <td style="width: 4rem; max-width: 4rem;"></td>
                                </ng-template>
                                <!-- end for space rowexpansion -->
                                <ng-container *ngFor="let col of columns">
                                    <td *ngIf="col.ischecked" style="text-align: left;">
                                        <ng-container *ngIf="!col?.depth; else depthTemplateChild">
                                            <ng-container *ngIf="col.field =='businessName'; else elseData">
                                                <app-color-box class="colorBoxStyle" [color]="children.classificationColor">
                                                </app-color-box>
                                                {{children[col.field] | shorten}}
                                            </ng-container>
                                            <ng-template #elseData>
                                                {{children[col.field]}}
                                            </ng-template>
                                        </ng-container>
                                        <ng-template #depthTemplateChild>
                                            {{children | field:col?.depth }}
                                        </ng-template>
                                    </td>
                                </ng-container>
                            </tr>
                            <ng-container *ngIf="children.childAccount && children.childAccount.length>0">
                                <ng-template [ngTemplateOutlet]="depth" [ngTemplateOutletContext]="{$implicit: children, columns:columns }">
                                </ng-template>
                            </ng-container>
                        </ng-container>

                    </ng-container>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="9">{{noAccountFindOrLoadingText}}</td>
                    </tr>
                </ng-template>
            </p-table>
            <!-- Lead -->
            <p-table #leads [columns]="leadCols" [lazy]="true" [totalRecords]="totalRecords4" [loading]="loading" [value]="leadsData" [rows]="pageSize4" [scrollable]="true" [style]="{width:'100%'}" [paginator]="true" selectionMode="multiple" [(selection)]="selectedLead"
                [rowsPerPageOptions]="tableShowMore4" dataKey="id" [(first)]="first4" (onLazyLoad)="getAllLeadsWithPagination($event)" [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" *ngIf="selectedModule.name == 'Lead'">
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-jc-between">
                        <!-- Filter Component -->
                        <app-filter [filterByInput]="activeLeadCols" [filterByInputValue]="filterByInputValue" [isShowAllDateFilter]="true" [enableAPIFilter]="true" (onApplyFilter)="onApplyFilter($event)" (onModifyFilterOptions)="onModifyFilterOptions($event)" (onChangeRange)="onChangeRange($event)"
                            (onRemoveFilter)="onRemoveFilter($event)" (onOptionsFilter)="onOptionsFilter($event)" style="width: 100%;" [panelDialog]="true">
                        </app-filter>
                        <span class="btnBars p-mr-0 p-mt-4" (click)="showColumnSetting()" pTooltip="Column Setting" tooltipPosition="top">
                            <i class="pi pi-cog"></i>
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="colgroup" let-columns>
                    <colgroup>
                        <ng-container *ngFor="let col of columns">
                            <col *ngIf="col.ischecked" style="width:auto">
                        </ng-container>
                    </colgroup>
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th style="width: 3rem">
                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                        </th>
                        <ng-container *ngFor="let col of columns">
                            <th *ngIf="col.ischecked" [pSortableColumn]="col.field">
                                {{col.labelname}}
                                <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                                <span class="pi pi-filter p-ml-2 filtericon" (click)="$event.stopPropagation(); curCol = col; op.toggle($event)">
                                </span>
                            </th>
                        </ng-container>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr [pSelectableRow]="rowData" [pContextMenuRow]="rowData">
                        <td>
                            <p-tableCheckbox [pSelectableRow]="rowData" [value]="rowData"></p-tableCheckbox>
                        </td>
                        <ng-container *ngFor="let col of columns">
                            <td *ngIf="col.ischecked" style="text-align: left;">
                                <ng-container *ngIf="!col?.depth; else depthTemplate">
                                    <ng-container *ngIf="col.field =='businessName'; else elseData">
                                        <app-color-box class="colorBoxStyle" [color]="rowData.stageColor">
                                        </app-color-box>
                                        {{rowData[col.field] | shorten }}
                                    </ng-container>
                                    <ng-template #elseData>
                                        <div>
                                            {{rowData[col.field]}}
                                            <span *ngIf="col.field === 'currentStage' && rowData.isConvertedToAccount
                                                && rowData.leadStageId==qualifiedId">
                                                *
                                            </span>
                                        </div>
                                    </ng-template>
                                </ng-container>
                                <ng-template #depthTemplate>
                                    {{rowData | field:col?.depth }}
                                </ng-template>
                            </td>
                        </ng-container>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="7">
                            <div class="p-text-center">{{noLeadFindOrLoadingText}}</div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>

    </ng-container>
    <ng-container *ngIf="layerNo == 3">
        <div class="card">
            <div class="p-grid" *ngFor="let s of fieldGroup;let i=index;">
                <div class="p-col-5" *ngIf="methodValue == 'saveSearch'">
                    <p-dropdown [options]="selectedSearch.columns" [(ngModel)]="selectedColumn" placeholder="Select a Field" optionLabel="header" [showClear]="true" appendTo="body"></p-dropdown>
                </div>
                <div class="p-col-5" *ngIf="methodValue == 'manually' && selectedAccounts.length > 0">
                    <p-dropdown [options]="selectedAccounts?.columns" [(ngModel)]="selectedColumn" placeholder="Select a Field" optionLabel="header" [showClear]="true" appendTo="body"></p-dropdown>
                </div>
                <div class="p-col-2 p-mt-2">
                    New Value =>
                </div>
                <div class="p-col-5">
                    <input type="text" pInputText>
                </div>
                <div class="p-col-1 p-text-right p-mt-2">
                    <span class="btnBars p-mr-2" (click)="removeFieldGroup(i)" *ngIf="i > 0">
                        <i class="pi pi-minus"></i>
                    </span>
                    <span class="btnBars" (click)="addFieldGroup()">
                        <i class="pi pi-plus"></i>
                    </span>
                </div>
            </div>
        </div>
    </ng-container>
    <p-footer>
        <button type="button" *ngIf="layerNo == 1" pButton (click)="cancel()" label="Cancel" class="p-button-secondary"></button>
        <button type="button" *ngIf="layerNo == 1 && saveSearchForm.valid && selectedSearch && methodValue == 'saveSearch'"
        pButton class="p-button-success" label="Next" (click)="showList('Select')"></button>
        <button type="button" *ngIf="layerNo == 1 && selectedModule && selectedChannel && methodValue == 'manually'"
        pButton class="p-button-success" label="Next" (click)="getDataLists()"></button>

        <button type="button" *ngIf="layerNo == 2" pButton (click)="layerNo = 1" label="Back"></button>
        <button type="button" *ngIf="layerNo == 2" pButton class="p-button-success" label="Next" (click)="showChange()"></button>

        <button type="button" *ngIf="layerNo == 3" pButton (click)="layerNo = 2" label="Back"></button>
        <button type="button" *ngIf="layerNo == 3" pButton class="p-button-success" label="Submit" (click)="save()"></button>
    </p-footer>
</p-dialog>

<!-- Column Settings -->
<p-dialog header="Column Settings" [(visible)]="displayColSetting" [style]="{width: '550px'}" [modal]="true" [baseZIndex]="10000">
    <div class="card">
        <div class="p-d-flex">
            <div>
                <h6>Column Selection (Max 12)</h6>
            </div>
        </div>
        <div>
            <input type="text" class="inputStyle p-inputtext" pInputText placeholder="Search for fields" [(ngModel)]="colSettingSearchInput">
        </div>
        <div cdkDropList [cdkDropListData]="selectedSearch?.savedSearchColumnSetting" (cdkDropListDropped)="dropListCol($event)">
            <ng-container *ngFor="let module of selectedSearch?.savedSearchColumnSetting; let idx = index">
                <div class="colList" cdkDrag (cdkDragStarted)="cdkDragStarted()" (cdkDragReleased)="cdkDragReleased()">
                    <div (click)="toggleChilds(module)">
                        <h6 class="moduleLabel"><i class="pi p-mr-3" [ngClass]="{'pi-minus': !module?.hideChilds,'pi-plus': module?.hideChilds}"></i>{{module.mapObject}}
                        </h6>
                    </div>
                    <div *cdkDragPreview>
                        <h6 class="moduleLabel p-pl-3" style="min-width: 200px;">{{module.mapObject}}</h6>
                    </div>
                    <div *ngIf="!module?.hideChilds" class="sub-columns" cdkDropList [cdkDropListData]="module.columns" (cdkDropListDropped)="dropCol($event)">
                        <ng-container *ngFor="let col of module.fields | gblFilter: colSettingSearchInput: 'labelName' ; let i = index">
                            <div class="colList" cdkDrag [cdkDragDisabled]="i === 0 || !col.moveable" appendTo="body">
                                <div class="p-d-flex">
                                    <i class="fa fa-bars p-mt-1 p-mr-2" [style.color]="!col.moveable ? 'lightgray' : 'var(--primary-color)' "></i>
                                    <p-checkbox *ngIf="!(col.nestedFields?.length > 0)" [(ngModel)]="col.isSelected" type="checkbox" binary="true" inputId="binary" (onChange)="onCheckChange($event.checked, col, null)" class="p-mr-2" [disabled]="(!col.isSelected && totalAmt >= 12) || col?.fieldName == 'BusinessName' || col?.fieldName == 'Name'">
                                    </p-checkbox>
                                    <span class="p-mt-1">{{col.labelName}}</span>
                                    <button type="button" pButton pRipple class="p-button-text p-button-rounded p-button-plain p-ml-2" [icon]="col.nestedFields?.length > 0 && col?.showChildrens ? 'pi pi-minus' : 'pi pi-plus'" *ngIf="col.nestedFields?.length > 0" (click)="showChild(col)"
                                        style="height: 20px; width: 20px;">
                                    </button>
                                </div>
                                <div *ngIf="col.nestedFields?.length > 0 && col?.showChildrens">
                                    <ul>
                                        <li *ngFor="let childCol of col.nestedFields">
                                            <p-checkbox [(ngModel)]="childCol.isSelected" type="checkbox" binary="true" inputId="binary" (onChange)="onCheckChange($event.checked, col, col.nestedFields)" class="p-mr-2" [disabled]="(!childCol.isSelected && totalAmt >= 12)">
                                            </p-checkbox>
                                            {{childCol.labelName}}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
    <p-footer>
        <button type="button" pButton (click)="displayColSetting=false;" label="Cancel" class="p-button-secondary"></button>
        <button type="submit" pButton label="Save" (click)="updateColumnSettings()"></button>
    </p-footer>
</p-dialog>

<app-manually-setting [module]="selectedModule" [channel]="selectedChannel" [display]="displayMannuallySettings" [columnSettingsConfig]="columnSettingsConfig" [allColumnSettings]="allColumnSettings" (onUpdateSetting)="onUpdateSetting($event)" *ngIf="displayMannuallySettings"
    [settingObj]="settingObj" (onUpdateProcess)="onUpdateProcess($event)" (cancelClicked)="settingCancelClicked($event)" [objectId]="objectId">
</app-manually-setting>
